module.exports = ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}"


// WEBPACK FOOTER //
// webpack://ClassicEditor/ckeditor5-block-quote/theme/blockquote.css